<template>
    <div> 
        <div class="navBarImg">
            <img class="img1" src="@/assets/image/图标-20.png" alt="" @click="back" />
            <div class="title">活动详情</div>
            <img style="visibility: hidden;" class="img2" src="@/assets/image_message_appear/iconHelp.png" alt="">
        </div>
        <div style="height: 11.74vw;"></div>
        <div class="bg_bar" v-if="activityObj.headImg == ''"></div>
        <div class="bg_bar" style="height: auto;" v-else>
            <img :src="activityObj.headImg" alt="" />
        </div>
        <div class="bg_box">
            <!-- 招募条件 -->
            <div class="recruit_condition recruit_info" v-for="(item, index) in activityObj.activeContent" :key="index">
                <div class="within">
                    <span>{{ item.type }}</span>
                    <img class="img1" src="@/assets/image_message_appear/title_bg@3x.png" />
                    <!-- 1 text 2 img -->
                    <div class="time" v-if="item.showType == 1">
                        <div v-if="index == 0" class="new_invite">
                            <div>招募时间:</div>
                            <div>{{ activityObj.signTimeStart }}-{{ activityObj.signTimeEnd }}</div>
                            <div>招募人数:</div>
                            <div>已报名/报名上限人数 &nbsp; {{ activityObj.applyNum }} / {{ activityObj.limitNum }}</div>
                            <div>招募内容:</div>
                        </div>
                        <div v-html="item.text" style="word-break: break-all;"></div>
                        <div @click="e => detailTypeImg(item.linkUrl)">
                            <span>{{ item.link }}</span>
                        </div>
                    </div>
                    <div class="detailType" v-if="item.showType == 2">
                        <div v-if="index == 0" class="new_invite">
                            <div>招募时间:</div>
                            <div>{{ activityObj.signTimeStart }}-{{ activityObj.signTimeEnd }}</div>
                            <div>招募人数:</div>
                            <div>已报名/报名上限人数 &nbsp; {{ activityObj.applyNum }} / {{ activityObj.limitNum }}</div>
                            <div>招募内容:</div>
                        </div>
                        <img @click="e => detailTypeImg(item.linkUrl)" :src="item.pic" alt="">
                    </div>
                </div>
            </div>
            <!-- <div class="detailContent">
                <span v-if="activityObj.detailType == 'text'">{{ activityObj.detailContent }}</span>
                <iframe v-if="activityObj.detailType == 'link'" :src="activityObj.detailContent"></iframe>
                <img v-if="activityObj.detailType == 'pic'" :src="activityObj.detailContent">
            </div> -->
            <div v-if="taskObj != null">
                <div class="infiniteloading_within" id="scroll">
                    <span>任务列表</span>
                    <img class="img1" src="@/assets/image_message_appear/title_bg@3x.png" />
                    <div class="title">点击下方列表中的任务，去完成采集</div>
                    <div class="task_list_box">
                        <nut-infiniteloading
                            class="infiniteloading"
                            containerId='scroll'
                            :use-window='false'
                            :has-more="hasMore"
                            :use-capture="true"
                            load-more-txt=""
                            load-icon="loading"
                        >
                            <div class="condition" v-for="(item, index) in taskObj" :key="index"
                            :style="{ background: item.state != 2 ? '#F6F6F6' : '#F3F7FF' }" @click="e => receiverTask(item)">
                                <span>{{ item.name }}</span>
                                <img src="@/assets/image/图标-20.png">
                            </div>
                            <template v-slot:finished>
                                <span></span>
                            </template>
                        </nut-infiniteloading>
                    </div>
                </div>
            </div>
            <div class="footer_btn" v-if="showFooterBtn">
                <!-- 报名 -->
                <nut-button v-if="applyBtnType == 1" class="apply_btn apply_type_1" shape="square" type="info" @click="applyBtn(1)">立即参与</nut-button>
                <!-- 错过报名 -->
                <nut-button v-else-if="applyBtnType == 2" class="apply_btn apply_type_2" shape="square" type="info" @click="applyBtn(2)">报名活动已经结束</nut-button>
                <!-- 取消报名 -->
                <div v-else-if="applyBtnType == 3" class="apply_suc_ed apply_type_3">
                    <nut-button class="textcolor3 apply_cancle" shape="square" type="info" @click="applyBtn(3)">取消报名</nut-button>
                    <span class="apply_success">报名成功</span>
                </div>
                <!-- 申请退出 -->
                <div v-else-if="applyBtnType == 4" class="apply_suc_ed apply_type_4">
                    <nut-button class="textcolor3 apply_cancle" shape="square" type="info" @click="applyBtn(4)">申请退出</nut-button>
                    <span class="apply_success">已报名，等待选拔结果</span>
                </div>
                <!-- 已退出 -->
                <nut-button v-else-if="applyBtnType == 5" class="apply_btn apply_type_5" shape="square" type="info">已申请退出，期待您的下次参与</nut-button>
                <!-- 被录取-退出 -->
                <div v-else-if="applyBtnType == 6" class="apply_suc_ed apply_type_6">
                    <nut-button class="textcolor3 apply_cancle" shape="square" type="info" @click="applyBtn(4)">申请退出</nut-button>
                    <span class="apply_success">已选中，等待任务下发</span>
                </div>
                <!-- 候补-退出 -->
                <div v-else-if="applyBtnType == 7" class="apply_suc_ed apply_type_7">
                    <nut-button class="textcolor3 apply_cancle" shape="square" type="info" @click="applyBtn(4)">申请退出</nut-button>
                    <span class="apply_success">候补中，仍有机会参与</span>
                </div>
                <!-- 分配任务-退出 -->
                <div v-else-if="applyBtnType == 8" class="apply_suc_ed apply_type_8">
                    <nut-button class="textcolor3 apply_cancle" shape="square" type="info" @click="applyBtn(5)">申请退出</nut-button>
                    <span class="apply_success">任务已下发请及时完成</span>
                </div>
                <!-- 活动过期-已报名 -->
                <nut-button v-else-if="applyBtnType == 9" class="apply_btn apply_type_9" shape="square" type="info" @click="applyBtn(6)">报名活动已结束,请关注后续活动通知</nut-button>
                <!-- 没有被录取 -->
                <nut-button v-else-if="applyBtnType == 10" class="apply_btn apply_type_10" shape="square" type="info">您因{{ unApplyDesc }}被取消录取，期待下次参与~</nut-button>
                <!-- 没有被录取 -->
                <nut-button v-else-if="applyBtnType == 11" class="apply_btn apply_type_10" shape="square" type="info">抱歉，本次您未被选中，期待您的下次参与~</nut-button>
            </div>
        </div>
    </div>
    <!-- <div class="loading_icon">
        <nut-icon name="loading" size="24"></nut-icon>
    </div> -->
    <!-- 报名 -->
    <nut-popup teleport="#app" v-model:visible="showApplyPopup" :close-on-click-overlay="false" 
    style="width: 82.3vw;padding: 4px 0;background: transparent;box-sizing: border-box;min-height: 65%" 
    pop-class="getUserInfoPopup getUserInfoPopup_2">
        <div class="recruit_condition">
            <div class="within">
                <span>报名信息填写</span>
                <img class="img1" src="@/assets/image_message_appear/title_bg@3x.png" />
                <div class="user_write">
                    <nut-form :model-value="userInfo" ref="applyRuleForm">
                        <nut-form-item label="手机号" prop="phone">
                            <input class="nut-input-text" @blur="customBlurValidate('phone')" v-model="userInfo.phone"
                            placeholder="请输入" type="text" />
                        </nut-form-item>
                        <nut-form-item label="QQ号" prop="qq">
                            <input class="nut-input-text" @blur="customBlurValidate('qq')" v-model="userInfo.qq"
                            placeholder="请输入" type="text" />
                        </nut-form-item>
                        <nut-form-item label="微信号" prop="wx">
                            <input class="nut-input-text" @blur="customBlurValidate('wx')" v-model="userInfo.wx"
                            placeholder="请输入" type="text" />
                            <div class="error">{{ userWriteInfo }}</div>
                        </nut-form-item>
                        <nut-cell class="footer_btn">
                            <nut-button type="primary" size="small" @click="submit('apply')">确定</nut-button>
                        </nut-cell>
                    </nut-form>
                </div>
            </div>
        </div>
        <img class="img2" @click="showApplyPopup = false;userWriteInfo = ''" src="@/assets/image_message_appear/关闭.png" alt="">
    </nut-popup>
    <!-- 取消报名 -->
    <nut-popup teleport="#app" position="bottom" lock-scroll v-model:visible="showUNApplyPopup" :close-on-click-overlay="false"  pop-class="getUserInfoPopup">
        <span class="required">请选择取消报名的原因</span>
        <div>
            <div class="unapply_content" v-for="item in columns" :key="item.value">
                <span>{{ item.text }}</span>
                <img v-if="item.select" src="@/assets/image_message_appear/选中@3x.png" @click="e => changeCloumns(item.value)">
                <img v-else src="@/assets/image_message_appear/未选中@3x.png" @click="e => changeCloumns(item.value)">
            </div>
        </div>
        <div class="problem_explain" v-if="columns[4].select">
            <span>问题说明</span>
            <textarea class="textarea" style="resize: none;" v-model="formData.reason" placeholder="请输入原因" />
        </div>
        <div class="border" :style="{marginTop: columns[4].select ? '5.6vw' : '11.2vw'}"></div>
        <div class="footer_btn">
            <nut-button class="cancle" size="small" @click="showUNApplyPopup = false;columns.map(item => item.select = false)">取消</nut-button>
            <nut-button class="confirm" type="primary" size="small" @click="submit('unapply')">确认</nut-button>
        </div>
    </nut-popup>
    <!-- 申请退出 -->
    <nut-popup teleport="#app" v-model:visible="showLogUpPopup" :close-on-click-overlay="false" style="width: 89vw;border-radius: 1.8vw;" pop-class="getUserInfoPopup">
        <span class="required" style="paddingLeft: 6.7vw;">确认申请退出？</span>
        <div class="exit_info" v-if="applyBtnType == 4">
            <span>退出后将无法继续参加选拔；30天内将无法报名其他招募活动！</span><br />
        </div>
        <div class="exit_info" v-if="applyBtnType == 8">
            <span>退出后将无法继续参加选拔，30天内将无法报名其他招募活动，并且账号拉黑7天！</span><br />
        </div>
        <div class="footer_btn unapply_footer exit_popup" style="margin: 0;margin-bottom: 11.1vw;">
            <nut-button class="exit_cancle" size="small" @click="showLogUpPopup = false;">取消</nut-button>
            <nut-button class="select_exit" type="primary" size="small" @click="submit('logup')">去选择退出原因</nut-button>
        </div>
    </nut-popup>
    <!-- 分配任务申请退出后 -->
    <nut-popup teleport="#app" v-model:visible="showReceiveTaskLogUpPopup" style="width: 80%;" pop-class="getUserInfoPopup">
        <h4>被取消录取原因</h4>
        <p>您因{{ unApplyDesc }}，被取消录取资格，并将扣除对应的积分，请认真对待任务。</p>
        <nut-cell class="footer_btn unapply_footer">
            <nut-button size="small" @click="showReceiveTaskLogUpPopup = false;">我知道了</nut-button>
        </nut-cell>
    </nut-popup>
    <!-- 放弃参加原因选择 -->
    <nut-picker
        v-model:visible="showUNApplyReasonPicker"
        :columns="columns"
        title="请选择"
        @confirm="PickerConfirm"
    >
    </nut-picker>
    <!-- 信息展示 -->
    <nut-popup :overlay="false" :style="toastObj.style" v-model:visible="toastObj.show">
        <img v-if="toastObj.img" class="icon_sucess" src="@/assets/image_message_appear/成功@3x.png" />
        <span :class="toastObj.class">{{ toastObj.text }}</span>
    </nut-popup>
</template>
<script setup>
import { 
    reactive,
    onMounted,
    ref,
} from 'vue'
import { Toast } from '@nutui/nutui';
import request from '@/utils/request'
import * as api from './helper/api.js'
import md5 from 'js-md5';
import { jsonp } from 'vue-jsonp'
// import { useStore } from 'vuex';
// import { 
//     getObjectUrl
// } from '@/utils/cos'
// import {
//     taskStatusOptions
// } from './helper/config'
const easyearn = window.easyearn
// 报名按钮类型 1 立即参与 2 活动结束 3 报名成功-取消 4 报名成功-申请退出 5 已申请退出 6 录取-退出 7 候补-退出 8 分配任务-退出 9 活动过期-已报名 10 没有被录取 11 落选
// const store = useStore() 
const applyBtnType = ref(1) 
const showApplyPopup = ref(false)
const showUNApplyPopup = ref(false)
const showLogUpPopup = ref(false)
const showFooterBtn = ref(false)
const showUNApplyReasonPicker = ref(false)
const showReceiveTaskLogUpPopup = ref(false) // 是否展示被取消录取
const showPunishment3 = ref(false) // 是否展示惩罚第三条
const applyRuleForm = ref(null);
const taskObj = ref(null); // 被分配的任务详情
const unApplyDesc = ref(null);
const userWriteInfo = ref(null); // 用户填写错误手机信息的提示
const timer = ref(null);
const hasMore = ref(false)
const ableSubmit = ref(true)
const signRecordId = ref(null) // 报名记录ID
const cityAdcode = ref(null)// 城市code
const searchId = ref(null) // 任务ID
const userOpenId = ref(null) // 用户openId
const userLatLng = ref(null) // 用户坐标
const originType = ref(null) // 步骑行/道路
const columns = reactive([
    { text: '时间不合适，无法参加', value: '0', select: false },
    { text: '身体原因', value: '1', select: false },
    { text: '之前是误报名', value: '2', select: false },
    { text: '活动不够吸引，不想参加了', value: '3', select: false },
    { text: '其他', value: '4', select: false },
])
// 弹框信息
const toastObj = reactive({
    style: {
        width: '85.4vw',
        padding: '21px 0',
        background: '#000',
        opacity: 0.5,
        color: '#fff',
        borderRadius: '16px',
    },
    show: false,
    img: false,
    class: 'showApplyPopup_Toast_uncondition',
    text: '',
})
// 用户信息
const userInfo = reactive({
    phone: '',
    wx: '',
    qq: ''
})
// 取消报名
const formData = reactive({
    reason: '',
})
// 报名
const activityObj = reactive({
    activeContent: [], // 活动想起
    max: '', // 报名人数上限
    current: '', // 当前报名人数
    headImg: '', // 头图
    detailType: '', // 详情类型 text、link、pic
    detailContent: '', // 详情内容
    signTimeEnd: '',
    signTimeStart: '',
    applyNum: '',
    limitNum: ''
})
onMounted(() => {
    setTimeout(() => {
        showFooterBtn.value = true
    }, 2000);
    userOpenId.value = easyearn ? easyearn.getOpenId() : 'oA9LiwOVHRl63Ax_H19o7jQ0O8Xo' // oA9LiwN-Im6HJCsAOa_-n-7y5TzI
    userLatLng.value = easyearn ? JSON.parse(easyearn.getUserLocation()) : {latitude: '39.981682', longitude: '116.306433'}
    // 获取客户端和银河传的id
    searchId.value = Number(window.location.search.split('=')[1])
    getSignPageInfo(searchId.value)
    getUserLocationInfo()
    // TODO del
    // setTimeout(() => {
    //     applyBtnType.value = 8
    // }, 5000);
    // taskObj.value = [
    //     {
    //         "activityId": "91784", 
    //         "openid": "oA9LiwKQobL62mcxErCTE7Eb4N7U", 
    //         "name": "测试任务100012", 
    //         "pid": "190086591508", 
    //         "state": 2, 
    //         "price": 1, 
    //         "assignTime": "2024-04-07 16:30:04", 
    //         "operator": "joeyqin", 
    //         "user_id": "", 
    //         "source_id": "955781230094209024", 
    //         "task_pos": "POINT(110.12282400000008 19.944321999999993)", 
    //         "source_type": 8, 
    //         "sub_type": 5
    //     }
    // ]
})
// 获取用户报名页面信息
const getSignPageInfo = async (id, isGetAllowSignAgain = false) => {
    const lnglat = userLatLng.value
    const params = {
        activityId: Number(id),
        commonInfo: {
            openid: userOpenId.value,
            vcode: "31600000",
            version: "3.10.0",
            loc_x: lnglat.latitude,
            loc_y: lnglat.longitude,
        }
    }
    const res = await request('post', api.activity_recruit, params)
    if(res.code == 0){
        const resData = res.data
        let signTimeStart = new Date(resData.signTimeStart).getTime()
        let signTimeEnd = new Date(resData.signTimeEnd).getTime()
        // let activeTimeEnd = new Date(resData.activeTimeEnd).getTime()
        let nowTime = new Date().getTime()
        if(nowTime >= signTimeStart && nowTime <= signTimeEnd){
            applyBtnType.value = 1
        }else if(nowTime > signTimeEnd){
            applyBtnType.value = 2
        }
        activityObj.applyNum = `${resData.signedNum}`
        activityObj.limitNum = `${resData.signNumMax}`
        originType.value = resData.originType
        if(!isGetAllowSignAgain){
            getUserAdmitInfo(id, resData.signTimeEnd, resData.activeTimeEnd)
            const activeContent = resData.activeContent
            activityObj.headImg = resData.headImg
            activityObj.activeContent = activeContent
            activityObj.signTimeStart = `${resData.signTimeStart.substr(5, 2)}月${resData.signTimeStart.substr(8, 2)}日 ${resData.signTimeStart.substr(11,5)}`
            activityObj.signTimeEnd = `${resData.signTimeEnd.substr(5, 2)}月${resData.signTimeEnd.substr(8, 2)}日 ${resData.signTimeEnd.substr(11,5)}`
            if(activeContent.length > 0){
                activeContent.map((item, index) => {
                    const cosurl = item.pic.includes('http') ? item.pic : `https://${item.pic}`
                    item.showType == 2 && window.getReadOnlyPresignedUrlApi(cosurl).then(url => {
                        console.log(url, 'url');
                        activityObj.activeContent[index].pic = url;
                    }).catch(err => console.log(err, 'err'));
                    item.text = item.text ? decodeURIComponent(item.text) : item.text;
                })
            }
            activityObj.activeContent = activeContent
        }
    }
}
// 去重
const uniqueByProperty = (arr, prop) => {
    const result = [];
    const seen = new Set();

    for (const item of arr) {
        if (!seen.has(item[prop])) {
            seen.add(item[prop]);
            result.push(item);
        }
    }

    return result;
}
/**
 * 
 * @param {*} id 
 * @param {*} enterState 1.已录取 2.未录取-(取消候补/取消落选) 3.候补中-透传 4.已落选 0.默认 5 取消录取 6 候补中-不透传
 * @param {*} state 1.报名 2 取消报名 3退出
 */
const getSignAssigned = async (id, enterState, state, activeTimeEnd) => {
    // const signTimeEnd2 = new Date(signTimeEnd).getTime()
    // const activeTimeEnd2 = new Date(activeTimeEnd).getTime()
    const params = {
        activityId: Number(id),
    }
    const res = await request('post', api.activity_sign_assigned, params)
    console.log(res, 'activity_sign_assigned');
    if(res.code == 0){
        switch (enterState) {
            case 1:
            case '1':{
                if(res.data.length == 0) {
                    applyBtnType.value = 6
                } else {
                    const arr = uniqueByProperty(res.data, 'pid')
                    taskObj.value = arr
                    applyBtnType.value = 8
                }
                break;
            }
            case 2:
            case 5:
            case '2':
            case '5':
                if(new Date().getTime() > new Date(activeTimeEnd).getTime()) applyBtnType.value = 11
                if(res.data.length > 0 && enterState == 5) applyBtnType.value = 11
                break;

            case 3:
            case '3':
                if(new Date().getTime() > new Date(activeTimeEnd).getTime()) applyBtnType.value = 11
                else applyBtnType.value = 7
                break;

            case 6:
            case '6':
                break;

            case 4:
            case '4':
                applyBtnType.value = 11
                break;
        
            default:
                break;
        }
        applyBtnType.value = state == 3 ? 5 : applyBtnType.value
    }
}
const getUserAdmitInfo = async (activityId, signTimeEnd, activeTimeEnd) => {
    const params = {
        filter:{
            activity_id: Number(activityId),
        }
    };
    const res = await request('post', api.activity_sign_list, params)
    console.log(res);
    if(res.code == 0){
        if(res.data.length > 0){
            const resData = res.data.filter(item => item.openid == userOpenId.value)
            if(resData.length > 0){
                const dataSort = resData.sort((a, b) => a.updateTime - b.updateTime)[0]
                const nowTime = new Date().getTime()
                const signTimeEnd2 = new Date(signTimeEnd).getTime()
                const activeTimeEnd2 = new Date(activeTimeEnd).getTime()
                getSignAssigned(activityId, dataSort.enterState, dataSort.state, activeTimeEnd, signTimeEnd)
                signRecordId.value = dataSort.id;
                switch (dataSort.state) {
                    // 已报名
                    case 1:
                    case '1':
                        if(nowTime > signTimeEnd2 && nowTime < activeTimeEnd2){
                            applyBtnType.value = 4;
                        }else if(nowTime < signTimeEnd2){
                            applyBtnType.value = 3;
                        }
                        break;
                    // 已取消报名
                    case 2:
                    case '2':
                        applyBtnType.value = new Date().getTime() < new Date(signTimeEnd).getTime() ? 1 : 5;
                        break;
                    // 已申请退出
                    case 3:
                    case '3':
                        applyBtnType.value = 5;
                        break;
                
                    default:
                        break;
                }
            }
        }
    }
}
// 点击图片跳转
const detailTypeImg = (url) => {
    if(url) window.location.href = url
}
// 失去焦点校验
const customBlurValidate = () => {
    const bool = Object.keys(userInfo).every(item => userInfo[item] == '' || userInfo[item] == undefined)
    if(bool){
        userWriteInfo.value = '请填写完整报名信息'
        return
    }
};
// 修改取消报名单选按钮
const changeCloumns = (value) => {
    columns.map(item => item.value == value ? item.select = !item.select : null)
    if(columns[4].select){
        formData.reason = ''
    }
}
// 领取任务
const receiverTask = (item) => {
    const stateErrorMap = [102, 5, 4, 1]
    if(stateErrorMap.includes(item.state)){
        Toast.text('该任务已失效，请重新挑选')
        return
    }
    if(item.user_id){
        Toast.text(`${item.user_id == item.openid ? '您已领取或提交该任务，无需重复领取' : '该任务已被其他用户领取，请重新挑选'}`)
        return
    }
    // 已退出不能领取
    if(applyBtnType.value == 5 || item.state != 2) return
    item.canAccept = 1
    if(originType.value == 2){
        easyearn && easyearn.gotoDetailPage(originType.value, item.source_type, JSON.stringify(item))
    }else if(originType.value == 1){
        const map = {
            1: [],
            4: [5,39],
            8: [],
            10: [],
            12: [],
        }
        Object.keys(map).map(mapItem => {
            if(mapItem == item.source_type){
                if(map[mapItem].length > 0){
                    const bool = map[mapItem].some(arrItem => arrItem == item.sub_type)
                    if(bool) easyearn && easyearn.gotoDetailPage(originType.value, item.source_type, JSON.stringify(item))
                    else Toast.text('请到任务地图页领取~')
                }else{
                    easyearn && easyearn.gotoDetailPage(originType.value, item.source_type, JSON.stringify(item))
                }
            }
        })
        if(!map[item.source_type]){
            Toast.text('请到任务地图页领取~')
        }
    }
}
// 报名
const applyBtn = (type) => {
    switch (type) { // 1 立即参与 2 活动结束  3 报名成功-取消 4 报名成功-申请退出
        case 1:
            // 可以报名
            if(!timer.value){
                timer.value = setTimeout(() => {
                    toastObj.show = false
                    timer.value = null
                }, 1000)
                showApplyPopup.value = true
            }
            break;
        case 2:
            Toast.text('本次招募活动已结束，请关注后续的招募活动~')
            break;
        case 3:
            showUNApplyPopup.value = true
            break;
        case 4:{
            showLogUpPopup.value = true
            break;
        }
        case 5:
            showLogUpPopup.value = true
            showPunishment3.value = true
            break;
        case 6:
            unApplyDesc.value = 'xxxx'
            break;
    
        default:
            break;
    }
}
// 取消报名选择
const PickerConfirm = ({ selectedValue }) => {
    formData.reason = selectedValue.join('') == '4' ? '' : selectedValue.join('')
    unApplyDesc.value = columns.filter(item => item.value == selectedValue.join(''))[0].text
}
// 提交用户信息
const submit = async (type) => {
    if(!ableSubmit.value) return
    ableSubmit.value = false
    switch (type) {
        // 提交用户信息
        case 'apply':{
            if(!timer.value && validtor()){
                const params = {
                    activityId: Number(searchId.value),
                    adcode: cityAdcode.value,
                    phone: userInfo.phone,
                    QQNum: userInfo.qq,
                    wx: userInfo.wx,
                    commonInfo: {
                        openid: userOpenId.value,
                        vcode: "31600000",
                        version: "3.10.0",
                        loc_x: userLatLng.value.latitude,
                        loc_y: userLatLng.value.longitude,
                    }

                }
                const res = await request('post', api.activity_sign, params)
                console.log(res, 'res');
                if(res.code == 0){
                    showApplyPopup.value = false
                    userWriteInfo.value = ''
                    toastObj.img = true
                    toastObj.text = '报名成功'
                    toastObj.style.width = '34vw';
                    toastObj.style.padding = '6.83vw 0 7.2vw';
                    toastObj.class = 'showApplyPopup_Toast_success'
                    toastObj.show = true
                    applyBtnType.value = 3
                    // 获取最新的用户数据的id
                    getSignRecordId()
                    // 修改报名人数
                    setApplyNum()
                } else{
                    let msg = res.msg
                    if(res.code == 90017) msg = '您暂不满足本次报名条件，请关注后续的招募活动~'
                    toastObj.img = false
                    toastObj.text = msg
                    toastObj.style.width = '85.4vw';
                    toastObj.class = 'showApplyPopup_Toast_uncondition'
                    toastObj.show = true
                }
                timer.value = setTimeout(() => {
                    toastObj.show = false
                    timer.value = null
                }, 1000)

            }
            break;
        }
        // 取消报名
        case 'unapply': {
            if(!timer.value){
                // 取消报名
                const arr = columns.filter(item => item.select == true).map(item => item.text)
                if(arr.length == 0) return
                if(arr.includes('其他')) {
                    const index = arr.findIndex(item => item == '其他')
                    arr[index] = '其他:' + formData.reason
                }
                const reason = arr.join(';')
                const params = {
                    id: Number(signRecordId.value),
                    reason
                }
                const res = await request('post', api.activity_sign_cancel, params)
                if(res.code == 0){
                    toastObj.img = true
                    toastObj.text = '取消成功'
                }else{
                    toastObj.img = false
                    toastObj.text = '取消失败'
                }
                showUNApplyPopup.value = false
                columns.map(item => item.select = false)
                toastObj.style.width = '34vw';
                toastObj.style.padding = '6.83vw 0 7.2vw';
                toastObj.class = 'showApplyPopup_Toast_success'
                if(applyBtnType.value == 3){
                    // 判断是否可以继续参与
                    getSignPageInfo(searchId.value, true)
                }else{
                    applyBtnType.value = res.code == 0 ? 5 : applyBtnType.value
                }
                toastObj.show = true
                timer.value = setTimeout(() => {
                    toastObj.show = false
                    timer.value = null
                }, 1000)
            }
            break;
        }
        // 申请退出
        case 'logup': {
            showLogUpPopup.value = false
            columns.map(item => item.select = false)
            showUNApplyPopup.value = true
            break;
        }
        default:
            break;
    }
    unApplyDesc.value = '';
    formData.reason = '';
    setTimeout(() => {
        ableSubmit.value = true
    }, 1000);
}
const getSignRecordId = async () => {
    const params = {
        filter:{
            activity_id: Number(searchId.value),
        }
    };
    const sign_listRes = await request('post', api.activity_sign_list, params)
    if(sign_listRes.code == 0){
        const resData = sign_listRes.data.filter(item => item.openid == userOpenId.value)
        if(resData.length > 0){
            const dataSort = resData.sort((a, b) => a.updateTime - b.updateTime)[0]
            signRecordId.value = dataSort.id;
        }
    }
}
const setApplyNum = async () => {
    const lnglat = userLatLng.value
    const params = {
        activityId: Number(searchId.value),
        commonInfo: {
            openid: userOpenId.value,
            vcode: "31600000",
            version: "3.10.0",
            loc_x: lnglat.latitude,
            loc_y: lnglat.longitude,
        }
    }
    const recruitRes = await request('post', api.activity_recruit, params)
    const recruitResData = recruitRes.data
    if(recruitRes.code == 0){
        activityObj.applyNum = `${recruitResData.signedNum}`
        activityObj.limitNum = `${recruitResData.signNumMax}`
    }
}
const debounce = (fn, delay) => {
    let timer
    return function () {
        let arg = arguments
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn(...arg)
        }, delay)
    }
}
// 通过坐标获取城市
const getUserLocationInfo = debounce(() => {
    const lnglat = easyearn ? JSON.parse(easyearn.getUserLocation()) : {latitude: '39.981682', longitude: '116.306433'}
    const key = 'JIOBZ-X43O4-SNVU7-D45ZU-F3LMS-K5BQT'
    const sk = 'THD7tcTnFmTnjYiVqCjYgmArpf75QXQ'
    const location = `${lnglat.latitude},${lnglat.longitude}`
    let sig = md5(`/ws/geocoder/v1?callback=jsonpCallback&key=${key}&location=${location}&output=jsonp${sk}`)
    sig = encodeURI(sig)
    jsonp('https://apis.map.qq.com/ws/geocoder/v1', {
        callbackQuery: 'callback',
        callbackName: 'jsonpCallback',
        key,
        location,
        output: 'jsonp',
        sig, // sig参数参考 https://lbs.qq.com/faq/serverFaq/webServiceKey
    }).then(res => {
        // 省直辖县级区划
        const map = [
            '429004', '429005', '429006', '429021', '419001', '469001', '469002', '469005', '469006', '469007',
            '469021', '469022', '469023', '469024', '469025', '469026', '469027', '469028', '469029', '469030',
            '659001', '659002', '659003', '659004', '659005', '659006', '659007', '659008', '659009', '659010'
        ]
        if(map.includes(res.result.ad_info.adcode)){
            cityAdcode.value = res.result.ad_info.adcode
        }else{
            cityAdcode.value = res.result.ad_info.adcode.slice(0, 4) + '00'
        }
    })
}, 300)
// 校验用户上报信息
const validtor = () => {
    for (const item in userInfo) {
        const element = userInfo[item];
        if(element == ''){
            toastObj.img = false
            toastObj.text = '请填写完整信息'
            toastObj.style.width = '85.4vw'
            toastObj.style.padding = '6.83vw 0 7.2vw';
            toastObj.class = 'showApplyPopup_Toast_uncondition'
            toastObj.show = true
            setTimeout(() => {
                toastObj.show = false
            }, 500);
            return false
        }
        const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        const reg2 = /^[1-9][0-9]{4,10}$/
        if((item == 'phone' && !reg.test(element)) || (item == 'qq' && !reg2.test(element))){
            toastObj.img = false
            toastObj.text = `请填写正确的${item == 'phone' ? '手机号' : 'QQ号'}`
            toastObj.style.padding = '6.83vw 0 7.2vw';
            toastObj.style.width = '85.4vw'
            toastObj.class = 'showApplyPopup_Toast_uncondition'
            toastObj.show = true
            setTimeout(() => {
                toastObj.show = false
            }, 500);
            return false
        }
    }
    return true
}
const back = () => {
    window.easyearn.goBack()
}
</script>
<style lang="scss" scoped>
    .navBarImg {
        z-index: 6;
        position: fixed;
        top: 0;
        display: flex;
        height: 56Px;
        width: calc(100% - 56Px);
        padding: 0 7.8vw 0 7.2vw;
        align-items: center;
        border-bottom: 1px solid #eaeaea;
        justify-content: space-between;
        background-color: #fff;
        .title {
            text-align: center;
            font: 16px bold;
        }
        img {
            width: 27Px;
            height: 27Px;
        }
        .img2{
            width: 21Px;
            height: 21Px;
        }
    }
    .bg_bar{
        height: 300px;
        background-image: linear-gradient(180deg, #A7B7FF 0%, #E0E4FE 100%);
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .bg_box{
        padding-top: 30px;
        background-image: linear-gradient(180deg, #9CB2FE 0%, #D1D9FF 100%);
    }
    .recruit_condition{
        width: 89.6vw;
        opacity: 0.96;
        background: #7E9DFF;
        border-radius: 12px;
        margin: 0 auto;
        padding: 6px 0;
        .within{
            width: 87.5vw;
            background: #FFFFFF;
            border-radius: 12px;
            position: relative;
            margin: 0 auto;
            padding: 57px 6.4vw;
            box-sizing: border-box;
            &>span{
                position: absolute;
                top: -10px;
                left: 17.9vw;
                display: block;
                width: 52vw;
                height: 38Px;
                margin: 0 auto;
                line-height: 38px;
                font-weight: 600;
                font-size: 18px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
                z-index: 5;
            }
            .img1{
                width: 52vw;
                height: 38px;
                position: absolute;
                left: 17.9vw;
            }
            .new_invite{
                div:nth-child(1),
                div:nth-child(3),
                div:nth-child(5){
                    height: 18px;
                    font-weight: 700;
                    color: rgb(1, 20, 103);
                    font-size: 13px;
                    line-height: 18px;
                    margin-bottom: 7px;
                }
                div:nth-child(2),
                div:nth-child(4){
                    height: 21px;
                    font-weight: 400;
                    // color: rgb(1, 20, 103);
                    font-size: 13px;
                    line-height: 21px;
                    margin-bottom: 20px;
                }
            }
            .time{
                margin-bottom: 28Px;
                font-size: 14px;
                & span:nth-child(1){
                    height: 5.1vw;
                    font-weight: 700;
                    line-height: 5.1vw;
                    margin-bottom: 2vw;
                    color: #011467;
                }
                & span:nth-child(2){
                    display: block;
                    height: 28Px;
                    font-weight: 400;
                    text-align: justify;
                    line-height: 28Px;
                }
            }
            .info{
                font-size: 14px;
                & span:nth-child(1){
                    height: 5.1vw;
                    font-weight: 700;
                    line-height: 5.1vw;
                    color: #011467;
                    margin-bottom: 2vw;
                }
                & span:nth-child(2){
                    display: block;
                    text-align: justify;
                    line-height: 5.9vw;
                }
            }
        }
    }
    .recruit_info{
        margin-top: 5.6vw;
        // height: auto;
        .within{
            padding-top: 16.94vw;
            padding-bottom:  6.4vw;
            // height: auto;
            .img1{
                top: -10px;
            }
            .condition{
                & span:nth-child(1){
                    height: 5.1vw;
                    font-weight: 700;
                    font-size: 3.9vw;
                    line-height: 5.1vw;
                    color: #011467;
                    margin-bottom: 2vw;
                }
                & span:nth-child(2){
                    display: block;
                    font-weight: 400;
                    font-size: 3.6vw;
                    text-align: justify;
                    line-height: 5.9vw;
                }
            }
            .detailType{
                img{
                    display: block;
                    width: 72.3vw;
                    height: 87.5vw;
                }
                padding: 4.4vw 0 0;
            }
        }
    }
    .per_info{
        font-size: 14px;
        text-align: center;
        padding: 10px 0;
    }
    .infiniteloading_within{
        width: 87.5vw;
        height: 159vw;
        background: #FFFFFF;
        border-radius: 3.4vw;
        position: relative;
        margin: 5vw auto 0;
        padding: 16.7vw 3.4vw 8.4vw;
        &>span{
            position: absolute;
            top: 0;
            display: block;
            width: 87.5vw;
            height: 7vw;
            line-height: 7vw;
            font-weight: 600;
            font-size: 5vw;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            z-index: 5;
        }
        .img1{
            width: 56.4vw;
            height: 11.1vw;
            position: absolute;
            top: -1.3vw;
            left: 19.7vw;
        }
        .title{
            height: 4.4vw;
            font-weight: 500;
            font-size: 3.1vw;
            text-align: justify;
            text-align: center;
            margin-bottom: 4.4vw;
        }
        .task_list_box{
            height: 150.54vw;
            overflow-y: auto;
            & div:nth-child(1){
                margin-top: 0;
            }
        }
        .condition{
            width: 78.54vw;
            background:#F3F7FF;
            border-radius: 2.8vw;
            margin-top: 2.3vw;
            padding: 4.4vw 2.8vw 4.4vw 5.4vw;
            display: flex;
            justify-content: space-between;
            &>span{
                display: inline-block;
                height: 4.1vw;
                font-weight: 500;
                font-size: 3.87vw;
                line-height: 4.1vw;
                vertical-align: middle;
            }
            img{
                width: 4.1vw;
                height: 4.1vw;
                transform: rotate(180deg);
                vertical-align: middle;
            }
        }
        .infiniteloading{
            & :deep(.nut-infinite-bottom){
                padding-top: 1.3vw;
            }
            & :deep(.nutui-iconfont){
                width: 3.7vw;
                height: 3.7vw;
            }
        }
    }

    // .detailContent{
    //     img{
    //         width: 100%;
    //         display: block;
    //     }
    //     padding: 10px 0;
    // }
    .footer_btn{
        text-align: center;
        .apply_type_1{
            margin: 33Px 0 28Px;
            font-size: 18px;;
        }
        .apply_type_2,
        .apply_type_5,
        .apply_type_9,
        .apply_type_10{
            margin: 30Px 0 28Px;
            background: #BDC4D0 !important;
            border-radius: 6.7vw !important;
            box-shadow: inset 4px 0 0 #AEAEAE,
            inset -4px 0 0 #AEAEAE !important;
            font-weight: 500;
            font-size: 5.1vw;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
        }
        .apply_type_3,
        .apply_type_4,
        .apply_type_6,
        .apply_type_7,
        .apply_type_8{
            padding: 5.6vw 0 3.4vw;
        }
        .apply_btn{
            width: 93.4vw;
            height: 13.4vw;
            background: #FB7A3C;
            border-radius: 6.7vw;
            box-shadow: inset 4px 0 0 #FF5C27,
            inset -4px 0 0 #FF5C27;
        }
        .apply_success{
            display: inline-block;
            width: 62.8vw;
            height: 13.4vw;
            line-height: 13.4vw;
            background: #42D6AD;
            border-radius: 6.7vw;
            font-weight: 500;
            font-size: 5.1vw;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            padding-right: 0;
            box-shadow: inset 4px 0 0 #31CEA3,
            inset -4px 0 0 #31CEA3;
        }
        .apply_cancle{
            display: inline-block;
            width: 27.73vw;
            height: 13.4vw;
            background: #F6F8FF;
            border-radius: 6.7vw;
            font-weight: 500;
            font-size: 5.1vw;
            color: #888888;
            letter-spacing: 0;
            text-align: center;
            line-height: 13.4vw;
            padding: 0;
            margin-right: 2.8vw;
        }
        .apply_type_8{
            padding-top: 7.5vw;
        }
        .apply_type_6,
        .apply_type_7{
            .apply_success{
                background: #FFC611;
                box-shadow: inset 4px 0 0 #FFAC00,
                inset -4px 0 0 #FFAC00;
            }
        }
        .apply_type_9,
        .apply_type_10{
            padding-left: 0;
            padding-right: 0;
        }
        .apply_type_10{
            font-size: 4.4vw;
            box-shadow: inset 1px 0 0 #AEAEAE,
            inset -1px 0 0 #AEAEAE !important;
        }
    }
    .loading_icon{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(50%, 50%);
    }
    .getUserInfoPopup{
        opacity: 0.96;
        background: #809EFE;
        position: relative;
        .recruit_condition{
            width: 82.3vw;
            .within{
                width: 80vw;
                padding-left: 0;
                padding-right: 0;
                padding-top: 19vw;
                padding-bottom: 0;
                &>span{
                    width: 100%;
                    margin-left: 0;
                }
                .img1{
                    left: 12vw;
                }
            }
        }
        .user_write{
            padding: 0 7.5vw 8Px;
            & :deep(.nut-form-item__label){
                width: 14.2vw;
                height: 10.5vw;
                font-weight: 700;
                font-size: 17Px;
                line-height: 10.5vw;
                margin-right: 0;
                text-align: left;
                &::before{
                    content: '';
                    margin-right: 0;
                }
            }
            & :deep(.nut-cell-group__warp){
                margin-bottom: 0;
                margin-top: 0;
                view:nth-child(1){
                    padding-top: 0;
                }
            }
            & :deep(.nut-form-item__body){
                height: 10.5vw;
            }
            & :deep(.nut-form-item.error.line)::before{
                border-bottom: none;
            }
            .nut-input-text{
                // margin-left: 3.4vw;
                height: 10.5vw;
                width: 49.34vw;
                border: 1px solid #88A4FE;
                border-radius: 19Px;
                box-sizing: border-box;
                padding-left: 12Px;
                &::placeholder{
                    height: 10.5vw;
                    line-height: 10.5vw;
                    opacity: 0.38;
                    font-weight: 500;
                    font-size: 17Px;
                    letter-spacing: 0;
                }
            }
            .error{
                height: 15px;
                font-weight: 400;
                font-size: 16Px;
                color: #FF4433;
                line-height: 15px;
                position: absolute;
                bottom: -12Px;
                right: 30Px;
                z-index: 5;
            }
            .footer_btn{
                padding: 5.2vw 0 0;
                & :deep(.nut-button){
                    width: 63.1vw;
                    height: 11.74vw;
                    background: #4B6CFD;
                    border-radius: 5.87vw;
                    font-size: 18px;
                    padding: 0;
                }
            }
        }
        .img2{
            position: absolute;
            bottom: 0;
            left: 35.4vw;
            width: 11.74vw;
            height: 11.74vw;
        }
        .nut-cell{
            display: flex;
            justify-content: space-evenly;
            .nut-button{
                padding: 0 10%;
            }
        }
        span.required{
            display: block;
            height: 16px;
            font-weight: 500;
            font-size: 21Px;
            color: #000000;
            line-height: 16px;
            padding: 26.88Px 0 26.88Px 32Px;
        }
        .unapply_content{
            width: 83.6vw;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            margin-bottom: 4.2vw;
            span{
                height: 3.8vw;
                font-weight: 400;
                font-size: 16Px;
                text-align: justify;
                line-height: 3.8vw;
            }
            img{
                width: 3.8vw;
                height: 3.8vw;
            }
        }
        .exit_info{
            width: 75.5vw;
            margin: 0 auto 5.6vw;
            font-weight: 400;
            font-size: 3.6vw;
            text-align: justify;
            line-height: 5.9vw;
        }
        .border{
            width: 94.13vw;
            border: 1Px solid #E5E5E5;
            margin: 11.2vw auto 0;
            transform: scaleY(0.5);
        }
        .select_picker{
            text-align: center;
            display: flex;
            justify-content: center;
            .nut-cell{
                width: 80%;
                border: 1px solid #CDCDCD;
            }
        }
        .unapply_reason_div{
            margin: 5% 0 0 10%;
            font-size: 14px;
        }
        .problem_explain{
            margin-left: 8.4vw;
            span{
                display: inline-block;
                height: 4.4vw;
                font-weight: 500;
                font-size: 4.4vw;
                line-height: 4.4vw;
                margin-top: 2.8vw;
            }
            .textarea{
                border: none;
                width: 82.54vw;
                height: 18.8vw;
                background: #F7F8FA;
                border-radius: 1.1vw;
                margin-top: 5.6vw;
                padding: 2vw 0 0 3.4vw;
                &:focus{
                    outline: none;
                }
            }
        }
        .footer_btn{
            margin: 3.5vw 0;
            & :deep(.cancle){
                width: 29.5vw;
                height: 11.7vw;
                line-height: 11.7vw;
                border: 1Px solid #4B6CFD;
                border-radius: 5.9vw;
                font-weight: 600;
                font-size: 4.4vw;
                color: #4B6CFD;
                letter-spacing: 0;
            }
            & :deep(.confirm){
                width: 55.6vw;
                height: 11.7vw;
                line-height: 11.7vw;
                background: #4B6CFD;
                border-radius: 5.9vw;
                margin-left: 2.8vw;
                font-weight: 500;
                font-size: 4.4vw;
                color: #FFFFFF;
                letter-spacing: 0;
            }
            & :deep(.exit_cancle){
                display: inline-block;
                border: none;
                height: 11.7vw;
                line-height: 11.7vw;
                font-weight: 600;
                font-size: 4.4vw;
                color: #4B6CFD;
                letter-spacing: 0;
                padding-right: 6.4vw;
            }
            & :deep(.select_exit){
                width: 42.3vw;
                height: 11.7vw;
                background: #4B6CFD;
                border-radius: 5.9vw;
                font-weight: 500;
                font-size: 4.4vw;
                color: #FFFFFF;
                letter-spacing: 0;
            }
        }
        .unapply_footer{
            margin-top: 20%;
        }
        .exit_popup{
            text-align: right !important;
            margin-right: 6vw !important;
        }
    }
    .getUserInfoPopup_2{
        .within{
            &>span{
                left: 0;
            }
            .img1{
                top: -3vw;
                left: 50% !important;
                transform: translateX(-50%);
            }
        }
    }
    .icon_sucess{
        display: block;
        width: 8.94vw;
        height: 8.94vw;
        margin: 0 auto 3.6vw;
    }
    .showApplyPopup_Toast_uncondition{
        display: block;
        width: 72vw;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        // line-height: 30px;
        margin: 0 auto;
    }
    .showApplyPopup_Toast_success{
        display: block;
        width: 18vw;
        margin: 0 auto;
        height: 16px;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        line-height: 16px;
    }
</style>
